// Container
const DefaultContainer = () => import('@/containers/DefaultContainer')

// Management
const CloserLeadPage = () => import('@/modules/closers/views/CloserLeadPage')
const CloserActiveList = () => import('@/modules/closers/views/CloserActiveList')
const CloserWarmTransferList  = () => import('@/modules/closers/views/CloserWarmTransferList')
const CloserLiveTransferList  = () => import('@/modules/closers/views/CloserLiveTransferList')
const CloserAddEquipmentList  = () => import('@/modules/closers/views/CloserAddEquipmentList')
const CloserCashAdvanceList  = () => import('@/modules/closers/views/CloserCashAdvanceList')
const CloserCallbackList  = () => import('@/modules/closers/views/CloserCallbackList')
const CloserIncompleteList  = () => import('@/modules/closers/views/CloserIncompleteList')
const CloserAgreementsOutList  = () => import('@/modules/closers/views/CloserAgreementsOutList')
const CloserReadyToReviewList  = () => import('@/modules/closers/views/CloserReadyToReviewList')
const CloserSubmissionStatusList  = () => import('@/modules/closers/views/CloserSubmissionStatusList')
const CloserPendingUnderwritingList  = () => import('@/modules/closers/views/CloserPendingUnderwritingList')
// const CloserApprovedNotInstalledList  = () => import('@/modules/closers/views/CloserApprovedNotInstalledList')
const CloserToBeTrainedList  = () => import('@/modules/closers/views/CloserToBeTrainedList')
const CloserPendingTransactionsList  = () => import('@/modules/closers/views/CloserPendingTransactionsList')
const CloserQuoteSentList  = () => import('@/modules/closers/views/CloserQuoteSentList')
const CloserDeclinedList  = () => import('@/modules/closers/views/CloserDeclinedList')
const CloserDashboard  = () => import('@/modules/closers/views/CloserDashboard')
const CloserHotLeadsList  = () => import('@/modules/closers/views/CloserHotLeadsList')

const NewCloserDashboard  = () => import('@/modules/closers/views/NewCloserDashboard')
const CloserKanbanBoard  = () => import('@/modules/closers/views/CloserKanbanBoard')
const CloserKanbanBoardSettingsPage  = () => import('@/modules/closers/views/CloserKanbanBoardSettingsPage')

var routes = [
    {
        path: '/closers',
        redirect: '/closers/leads',
        name: 'Closers',
        component: DefaultContainer,
        children: [
            {
				path: '/closers',
                name: 'CloserLeadPage',
				redirect: '/closers/new-dashboard',
                component: CloserLeadPage,
                meta: {
                    requiresAuth: true,
                    permission: false,
                },
				children: [
					{
						path: 'new-dashboard',
						name: 'NewCloserDashboard',
						component: NewCloserDashboard,
						meta: {
							requiresAuth: true,
							permission: false,
							tab: 'new-dashboard',
							role_filter: 'closer',
						},
					},
					{
						path: 'dashboard',
						name: 'CloserDashboard',
						component: CloserDashboard,
						meta: {
							requiresAuth: true,
							permission: false,
							tab: 'dashboard',
							role_filter: 'closer',
						},
					},
					{
						path: 'kanban-board',
						name: 'CloserKanbanBoard',
						component: CloserKanbanBoard,
						meta: {
							requiresAuth: true,
							permission: false,
							tab: 'kanban-board',
							role_filter: 'closer',
						},
					},
					{
						path: 'kanban-board-settings',
						name: 'CloserKanbanBoardSettingsPage',
						component: CloserKanbanBoardSettingsPage,
						meta: {
							requiresAuth: true,
							permission: false,
							role_filter: 'closer',
						},
					},
					{
						path: 'incompletes',
						name: 'CloserIncompleteList',
						component: CloserIncompleteList,
						meta: {
							requiresAuth: true,
							permission: false,
							tab: 'incompletes',
							role_filter: 'closer',
						},
					},
					{
						path: 'agreements-out',
						name: 'CloserAgreementsOutList',
						component: CloserAgreementsOutList,
						meta: {
							requiresAuth: true,
							permission: false,
							tab: 'agreements-out',
							role_filter: 'closer',
						},
					},
					{
						path: 'ready-to-review',
						name: 'CloserReadyToReviewList',
						component: CloserReadyToReviewList,
						meta: {
							requiresAuth: true,
							permission: false,
							tab: 'ready-to-review',
							role_filter: 'closer',
						},
					},
					{
						path: 'quote-sent',
						name: 'CloserQuoteSentList',
						component: CloserQuoteSentList,
						meta: {
							requiresAuth: true,
							permission: false,
							tab: 'quote-sent',
							role_filter: 'closer',
						},
					},
					{
						path: 'submission-status',
						name: 'CloserSubmissionStatusList',
						component: CloserSubmissionStatusList,
						meta: {
							requiresAuth: true,
							permission: false,
							tab: 'submission-status',
							role_filter: 'closer',
						},
					},
					{
						path: 'pending-underwriting',
						name: 'CloserPendingUnderwritingList',
						component: CloserPendingUnderwritingList,
						meta: {
							requiresAuth: true,
							permission: false,
							tab: 'pending-underwriting',
							role_filter: 'closer',
						},
					},
					// {
					// 	path: 'approved-not-installed',
					// 	name: 'CloserApprovedNotInstalledList',
					// 	component: CloserApprovedNotInstalledList,
					// 	meta: {
					// 		requiresAuth: true,
					// 		permission: false,
					// 		tab: 'approved-not-installed',
					// 		role_filter: 'closer',
					// 	},
					// },
					{
						path: 'to-be-trained',
						name: 'CloserToBeTrainedList',
						component: CloserToBeTrainedList,
						meta: {
							requiresAuth: true,
							permission: false,
							tab: 'to-be-trained',
							role_filter: 'closer',
						},
					},
					{
						path: 'pending-transactions',
						name: 'CloserPendingTransactionsList',
						component: CloserPendingTransactionsList,
						meta: {
							requiresAuth: true,
							permission: false,
							tab: 'pending-transactions',
							role_filter: 'closer',
						},
					},
					{
						path: 'leads',
						name: 'CloserActiveList',
						component: CloserActiveList,
						meta: {
							requiresAuth: true,
							permission: false,
							tab: 'leads',
							role_filter: 'closer',
						},
					},
					{
						path: 'callbacks',
						name: 'CloserCallbackList',
						component: CloserCallbackList,
						meta: {
							requiresAuth: true,
							permission: false,
							tab: 'callbacks',
							role_filter: 'closer',
						},
					},
					{
						path: 'warm-transfer',
						name: 'CloserWarmTransferList',
						component: CloserWarmTransferList,
						meta: {
							requiresAuth: true,
							permission: false,
							tab: 'warm-transfer',
							role_filter: 'closer',
						},
					},
					{
						path: 'live-transfer',
						name: 'CloserLiveTransferList',
						component: CloserLiveTransferList,
						meta: {
							requiresAuth: true,
							permission: false,
							tab: 'live-transfer',
							role_filter: 'closer',
						},
					},
					{
						path: 'add-equipment',
						name: 'CloserAddEquipmentList',
						component: CloserAddEquipmentList,
						meta: {
							requiresAuth: true,
							permission: false,
							tab: 'add-equipment',
							role_filter: 'closer',
						},
					},
					{
						path: 'cash-advance',
						name: 'CloserCashAdvanceList',
						component: CloserCashAdvanceList,
						meta: {
							requiresAuth: true,
							permission: false,
							tab: 'cash-advance',
							role_filter: 'closer',
						},
					},
					{
						path: 'declined',
						name: 'CloserDeclinedList',
						component: CloserDeclinedList,
						meta: {
							requiresAuth: true,
							permission: false,
							tab: 'declined',
							role_filter: 'closer',
						},
					},
					{
						path: 'hot-leads',
						name: 'CloserHotLeadsList',
						component: CloserHotLeadsList,
						meta: {
							requiresAuth: true,
							permission: false,
							tab: 'hot-leads',
							role_filter: 'closer',
						},
					},
				]
            },
        ]
    },

];

export default routes;
